// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"a889c651","64":"cce0e331","232":"af427317","453":"c0571e75"}[chunkId] + ".chunk.js";
};